// extracted by mini-css-extract-plugin
export default {"App":"app_App__uoG-z","AppCards":"app_AppCards__29MLH"};